import React, {createContext, useCallback, useContext, useMemo, useState} from 'react';
import MobileNavDrawer from './MobileNavDrawer';

const MobileNavContext = createContext(null);

export function MobileNavProvider({children}) {
    const [isOpen, setIsOpen] = useState(false);

    const openMenu = useCallback(() => setIsOpen(true), []);
    const closeMenu = useCallback(() => setIsOpen(false), []);

    const value = useMemo(() => ({
        openMenu,
        closeMenu,
        isMenuOpen: isOpen,
    }), [isOpen, openMenu, closeMenu]);

    return (
        <MobileNavContext.Provider value={value}>
            {children}
            <MobileNavDrawer isOpen={isOpen} onClose={closeMenu}/>
        </MobileNavContext.Provider>
    );
}

export function useMobileNav() {
    const ctx = useContext(MobileNavContext);
    if (!ctx) {
        throw new Error('useMobileNav باید داخل MobileNavProvider استفاده شود');
    }
    return ctx;
}
